"use strict";
import BtnBase from './btnbase';
import Browser from './../util/browser';

class BtnTab extends BtnBase{
	constructor($con){
		super($con);
		this.isRender = false;
	}
	
	init(){
		this.isInit = false;
		this.isCurrent = true;
		Browser.addResizeHandler(this.scrollresize,this);
		Browser.addScrollHandler(this.scrollresize,this);
		this.scrollresize();
	}
	
	preload(){
		if(this.isInit) return;
		this.isInit = true;
		
		this.data = BtnTab[this.$con.attr('id')];
		
		this.queue = new createjs.LoadQueue(false);
		
		this.queue.loadManifest(this.data.manifest,false);
	    this.queue.addEventListener("complete",()=>{
			this.init2();
	    });
	    this.queue.load();
	}
	
	init2(){
		let canvasid = this.$con.find('canvas').attr('id');
		this.stage = new createjs.Stage(canvasid);
		//this.stage.enableMouseOver();
		createjs.Ticker.addEventListener("tick",this.tick.bind(this) );
		
		this.stage.canvas.width = this.$con.width();	
		this.stage.canvas.height = this.$con.height();
		
		//IMG
		this.img = new createjs.Bitmap(this.queue.getResult('img'));
		this.stage.addChild(this.img);
		
		//COVER
		this.cover = new createjs.Shape();
		this.stage.addChild(this.cover);
		this.cover.graphics.beginFill( 
			createjs.Graphics.getRGB( Math.floor(this.data.bg.color.r), Math.floor(this.data.bg.color.g), Math.floor(this.data.bg.color.b) )
		);
		this.cover.graphics.drawRect(0,0,this.stage.canvas.width,this.stage.canvas.height);
		this.cover.alpha = 0.3;
		if(this.isCurrent){
			this.cover.alpha = 0;
		}
				
		//BG
		this.bg = new createjs.Shape();
		this.stage.addChild(this.bg);
		this.bg.x = this.stage.canvas.width - this.data.bg.width;
		this.bgobj = {
			x:25,
			r:Math.floor(this.data.bg.color.r),
			g:Math.floor(this.data.bg.color.g),
			b:Math.floor(this.data.bg.color.b)
		};
		
		//TXT
		this.txt = new createjs.Bitmap(this.queue.getResult('txt'));
		this.stage.addChild(this.txt);
		this.txt.x = this.data.txt.x;
		this.txt.y = this.data.txt.y;
		
		//CIRCLE
		this.circle = new createjs.Container();
		this.stage.addChild(this.circle);
		this.circle.x = this.data.circle.x;
		this.circle.y = this.data.circle.y;
		this.arrow = new createjs.Bitmap(this.queue.getResult('arrow'));
		this.arrow.filters = [new createjs.ColorFilter(0, 0, 0, 1 , this.data.circle.color.r , this.data.circle.color.g , this.data.circle.color.b , 0)];
		this.arrow.cache(0, 0, 20, 20);
		this.arrow.regX = 5;
		this.arrow.regY = 6;
		this.circle.addChild(this.arrow);
		this.circle1 = new createjs.Shape();
		this.circle.addChild(this.circle1);
		this.circle2 = new createjs.Shape();
		this.circle.addChild(this.circle2);
		

		
		this.circle1obj = {
			angle : {start : BtnTab.Common.circle1.angle.start , end : BtnTab.Common.circle1.angle.end }
		}
		this.circle2obj = {
			angle : {start :  BtnTab.Common.circle2.angle.start , end : BtnTab.Common.circle2.angle.end }
		}
		
	}
	
	tick(){
		if(!this.isRender) return;
		
		this.bg.graphics.clear();
		this.bg.graphics.beginFill( 
			createjs.Graphics.getRGB( Math.floor(this.bgobj.r), Math.floor(this.bgobj.g), Math.floor(this.bgobj.b) )
		);
		this.bg.graphics.moveTo(0,0);
		this.bg.graphics.lineTo(this.data.bg.width,0);
		this.bg.graphics.lineTo(this.data.bg.width,this.data.bg.height);
		this.bg.graphics.lineTo(0,this.data.bg.height);
		this.bg.graphics.quadraticCurveTo(this.bgobj.x,this.data.bg.height>>1,0,0);
		this.bg.graphics.endFill();
		
		this.circle1.graphics.clear();
		this.circle1.graphics.setStrokeStyle(8,"round");
		if(this.isHover){
			this.circle1.graphics.beginStroke( createjs.Graphics.getRGB( 255 , 255 , 255 ) );
		} else {
			this.circle1.graphics.beginStroke( createjs.Graphics.getRGB( this.data.circle.color.r , this.data.circle.color.g , this.data.circle.color.b ) );
		}
		
		this.circle1.graphics.arc(0,0,32,this.circle1obj.angle.start,this.circle1obj.angle.end);
		
		this.circle2.graphics.clear();
		this.circle2.graphics.setStrokeStyle(8,"round");
		if(this.isHover){
			this.circle2.graphics.beginStroke( createjs.Graphics.getRGB( 255 , 255 , 255 ) );
		} else {
			this.circle2.graphics.beginStroke( createjs.Graphics.getRGB( this.data.circle.color.r , this.data.circle.color.g , this.data.circle.color.b ) );
		}
		this.circle2.graphics.arc(0,0,32,this.circle2obj.angle.start,this.circle2obj.angle.end);
		
		this.stage.update();
	}
	
	scrollresize(){
		//scroll
		if( Browser.responsive == 'pc' || Browser.responsive == 'tb' ){
			let startY = this.$con.offset().top - Browser.windowHeight;
			let endY = startY + this.$con.height() + Browser.windowHeight;
			if( Browser.scrollY >= startY && Browser.scrollY < endY ){
				this.isRender = true;
			} else {
				this.isRender = false;
			}			
		} else {
			this.isRender = false;
		}
		
		//console.log( this.$con.attr('id') , startY , endY , Browser.scrollY );
		//console.log(startY , endY , Browser.scrollY);
	}
	
	responsiveHandler(){
		super.responsiveHandler();
		
		if( Browser.responsive == 'pc' ){
			this.preload();
			this.isRender = true;
		} else {
			this.isRender = false;
		}
		
	}
	
	over(){
		super.over();
		
		this.arrow.filters = [];
		this.arrow.cache(0, 0, 20, 20);
		
		createjs.Tween.get(this.bgobj,{override:true}).to({x:-6},500,createjs.Ease.elasticOut);
		createjs.Tween.get(this.bgobj,{override:false}).to({r:this.data.bg.color_hover.r,g:this.data.bg.color_hover.g,b:this.data.bg.color_hover.b},150);
		createjs.Tween.get(this.arrow,{override:false}).to({rotation:360},150);
		createjs.Tween.get(this.circle1obj.angle,{override:false}).to({
			start:BtnTab.Common.circle1.angle_hover.start
			,end:BtnTab.Common.circle1.angle_hover.end
		},400,createjs.Ease.backOut);
			createjs.Tween.get(this.circle2obj.angle,{override:false}).to({
			start:BtnTab.Common.circle2.angle_hover.start
			,end:BtnTab.Common.circle2.angle_hover.end
		},400,createjs.Ease.backOut);

		createjs.Tween.get(this.cover,{override:true}).to({alpha:0},100);
	}
	
	out(){
		super.out();
		
		this.arrow.filters = [new createjs.ColorFilter(0, 0, 0, 1 , this.data.circle.color.r , this.data.circle.color.g , this.data.circle.color.b , 0)];
		this.arrow.cache(0, 0, 20, 20);
		
		createjs.Tween.get(this.bgobj,{override:true}).to({x:25,r:this.data.bg.color.r,g:this.data.bg.color.g,b:this.data.bg.color.b},500,createjs.Ease.quintOut);
		createjs.Tween.get(this.arrow,{override:false}).to({rotation:0},150);
		createjs.Tween.get(this.circle1obj.angle,{override:false}).to({
			start:BtnTab.Common.circle1.angle.start
			,end:BtnTab.Common.circle1.angle.end
		},300,createjs.Ease.quintOut);
		createjs.Tween.get(this.circle2obj.angle,{override:false}).to({
			start:BtnTab.Common.circle2.angle.start
			,end:BtnTab.Common.circle2.angle.end
		},300,createjs.Ease.quintOut);
		
		if(this.isCurrent){
			createjs.Tween.get(this.cover,{override:true}).to({alpha:0},150);
		} else {
			createjs.Tween.get(this.cover,{override:true}).to({alpha:0.3},150);
		}
	}
	
	click(){
		super.click();
	}
	
	current(bool){
		this.isCurrent = bool;
	}

}

BtnTab.Common = {
	circle1 :{
		angle : {start:0,end:Math.PI*1.5},
		angle_hover : {start:Math.PI*0.63,end:Math.PI*0.87}
	},
	circle2 :{
		angle : {start:Math.PI*1.63,end:Math.PI*1.87},
		angle_hover : {start:Math.PI*1.0,end:Math.PI*2.5}
	}
}
BtnTab.BtnSanpo = {	
	manifest : [
        {"src":"./img/top/tabbtn/arrow_bottom.png","id":"arrow"},
        {"src":"./img/top/tabbtn/btn_img_sanpo.png","id":"img"},
        {"src":"./img/top/tabbtn/btn_txt_sanpo.png","id":"txt"}
	],
	bg : {
		color : {r:77,g:105,b:197},
		color_hover : {r:104,g:131,b:222},
		width : 240,
		height : 248
	},
	txt : {
		x : 322,
		y : 27
	},
	circle : {
		x : 406,
		y : 154,
		color : {r:204,g:198,b:201}
	}
}
BtnTab.BtnZoom = {	
	manifest : [
        {"src":"./img/top/tabbtn/arrow_bottom.png","id":"arrow"},
        {"src":"./img/top/tabbtn/btn_img_zoom.png","id":"img"},
        {"src":"./img/top/tabbtn/btn_txt_zoom.png","id":"txt"}
	],
	bg : {
		color : {r:57,g:63,b:75},
		color_hover : {r:75,g:86,b:108},
		width : 240,
		height : 248
	},
	txt : {
		x : 322,
		y : 27
	},
	circle : {
		x : 406,
		y : 154,
		color : {r:224,g:229,b:165}
	}
}
BtnTab.BtnZoomBottom = {	
	manifest : [
        {"src":"./img/common/tabbtn/arrow_right.png","id":"arrow"},
        {"src":"./img/common/tabbtn/btn_img_zoom_bottom.png","id":"img"},
        {"src":"./img/common/tabbtn/btn_txt_zoom_bottom.png","id":"txt"}
	],
	bg : {
		color : {r:57,g:63,b:75},
		color_hover : {r:75,g:86,b:108},
		width : 540,
		height : 219
	},
	txt : {
		x : 441,
		y : 70
	},
	circle : {
		x : 838,
		y : 110,
		color : {r:224,g:229,b:165}
	}
}
BtnTab.BtnSanpoBottom = {	
	manifest : [
        {"src":"./img/common/tabbtn/arrow_right.png","id":"arrow"},
        {"src":"./img/common/tabbtn/btn_img_sanpo_bottom.png","id":"img"},
        {"src":"./img/common/tabbtn/btn_txt_sanpo_bottom.png","id":"txt"}
	],
	bg : {
		color : {r:77,g:105,b:197},
		color_hover : {r:104,g:131,b:222},
		width : 540,
		height : 219
	},
	txt : {
		x : 441,
		y : 70
	},
	circle : {
		x : 838,
		y : 110,
		color : {r:204,g:198,b:201}
	}
}
BtnTab.BtnZoom = {	
	manifest : [
        {"src":"./img/common/tabbtn/arrow_right.png","id":"arrow"},
        {"src":"./img/common/tabbtn/btn_img_zoom_bottom.png","id":"img"},
        {"src":"./img/common/tabbtn/btn_txt_zoom_bottom.png","id":"txt"}
	],
	bg : {
		color : {r:57,g:63,b:75},
		color_hover : {r:75,g:86,b:108},
		width : 540,
		height : 219
	},
	txt : {
		x : 441,
		y : 70
	},
	circle : {
		x : 838,
		y : 110,
		color : {r:224,g:229,b:165}
	}
}



export default BtnTab;


// WEBPACK FOOTER //
// ./js/btn/btntab.js